const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- tpl-contacts ---
let __fez_component_0;
{

__fez_component_0 = class {
  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.items = []
    this.state.query = ''
    this.state.shown = ''
    this.state.seq = 0
  }

  onMount() {
    this.load()
  }

  async load() {
    const seq = ++this.state.seq
    const q = this.state.query
    try {
      const list = await window.App.api('contact/list', q ? { q } : {}, { silent: true })
      if (seq !== this.state.seq) return
      this.state.items = list.items
      this.state.shown = q
      this.state.error = ''
    } catch (error) {
      if (seq === this.state.seq) this.state.error = error.message
    } finally {
      if (seq === this.state.seq) this.state.loading = false
    }
  }

  search(value) {
    this.state.query = (value || '').trim()
    clearTimeout(this.state.timer)
    this.state.timer = this.setTimeout(() => this.load(), 200)
  }

  // A delete confirms in the dialog host, which resolves the dialog before the delete is done, so
  // the list reloads after every close, not only after a save.
  async edit(ref) {
    const contact = ref ? this.state.items.find((item) => item.ref === ref) : undefined
    await window.Dialog.open('contact-dialog', { contact }, { title: ref ? 'Edit contact' : 'Add contact' })
    await this.load()
  }

  beforeRender() {
    this.state.rows = this.state.items.map((contact) => ({
      ref: contact.ref,
      title: contact.name || contact.emails[0] || contact.phones[0]?.number || '',
      line: [contact.emails.join(', '), contact.phones.map((phone) => phone.number).join(', ')].filter(Boolean).join(' · '),
    }))
  }

  CSS = `:fez {
display:block;.contacts-page{max-width:var(--content-width);margin:0 auto;padding:var(--space-10) var(--space-6) var(--space-12)}.contacts-head{display:flex;align-items:flex-end;justify-content:space-between;gap:var(--space-4);margin-bottom:var(--space-6)}h1{font-size:var(--text-2xl);letter-spacing:-0.02em}.contacts-sub{margin-top:var(--space-2);color:var(--color-text-muted)}.contacts-search{display:flex;align-items:center;gap:var(--space-2);height:38px;margin-bottom:var(--space-4);padding:0 var(--space-3);border:1px solid var(--color-border-strong);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text-muted);&:focus-within{border-color:var(--color-accent)}}.contacts-search-input{flex:1;min-width:0;height:100%;padding:0;border:0;outline:none;background:transparent;color:var(--color-text);font:inherit} :mobile {.contacts-page{padding:var(--space-6) var(--space-4) var(--space-10)}.contacts-head{flex-direction:column;align-items:stretch}}
}`

  HTML = `<div class="contacts-page">
<div class="contacts-head">
<div>
<h1>Contacts</h1>
<p class="contacts-sub">People you send mail to or let into the Inbox are added here. Edit them as you like; they follow you in every mailbox.</p>
</div>
<ui-button variant="primary" icon="user-plus" label="Add contact" onclick="fez.edit()"></ui-button>
</div>
<label class="contacts-search">
<ui-icon name="magnifying-glass" size="18"></ui-icon>
<input type="search" class="contacts-search-input" placeholder="Search by name, address or phone" aria-label="Search contacts" oninput="fez.search(event.target.value)">
</label>
{#if state.error}
<ui-empty icon="warning-circle" title="Could not load your contacts" text={state.error}></ui-empty>
{:else if state.loading}
<ui-spinner></ui-spinner>
{:else if !state.rows.length}
{#if state.shown}
<ui-empty icon="magnifying-glass" title="No matches"></ui-empty>
{:else}
<ui-empty icon="address-book" title="No contacts yet" text="Send mail or add someone; they show up here."></ui-empty>
{/if}
{:else}
<ui-card padding="none">
{#each state.rows as row}
<div class="list-row clickable" key={row.ref} onclick="fez.edit('{row.ref}')">
<ui-avatar name={row.title} size="md"></ui-avatar>
<div class="list-main">
<strong>{row.title}</strong>
{#if row.line}<span>{row.line}</span>{/if}
</div>
</div>
{/each}
</ui-card>
{/if}
</div>`
};
}

Fez('tpl-contacts', __fez_component_0);

export default __fez_component_0;
